// react
import type { ReactNode } from 'react';

// material ui
import { Box, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// relative
import AppFooter from './AppFooter';
import { APPBAR_HEIGHT } from './constants';

interface MainContentProps {
  children: ReactNode;
  isMobile: boolean;
  frameBg: string;
}

export default function MainContent({
  children,
  isMobile,
  frameBg,
}: MainContentProps) {
  const theme = useTheme();

  return (
    <Box
      component="main"
      sx={{
        flex: 1,
        pt: `${APPBAR_HEIGHT}px`,
        pr: 2,
        pl: isMobile ? 2 : 0,
        minHeight: '100vh',
        bgcolor: frameBg,
        overflowX: 'hidden',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          height: '6px',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.divider,
          borderRadius: '3px',
        },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          height: `calc(100vh - ${APPBAR_HEIGHT}px)`,
          display: 'flex',
          flexDirection: 'column',
          borderTopLeftRadius: '6px',
          borderTopRightRadius: '6px',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          bgcolor:
            theme.palette.mode === 'light'
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          overflow: 'auto',
          overflowX: 'hidden',
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.divider,
            borderRadius: '3px',
          },
        }}
      >
        <Box sx={{ flex: 1 }}>{children}</Box>
        <AppFooter />
      </Paper>
    </Box>
  );
}
